import { render, staticRenderFns } from "./MotorPurchases.vue?vue&type=template&id=51133cd6&scoped=true&"
import script from "./MotorPurchases.vue?vue&type=script&lang=js&"
export * from "./MotorPurchases.vue?vue&type=script&lang=js&"
import style0 from "./MotorPurchases.vue?vue&type=style&index=0&id=51133cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51133cd6",
  null
  
)

export default component.exports